import ApiController from '@/services/ApiController'
import CookieFirstHelper from '@/services/helpers/CookieFirstHelper'
import { WALKER_COMMANDS } from '@/services/helpers/ElbwalkerHelper'
import destinationGoogleGA4 from '@elbwalker/destination-web-google-ga4'
import { elb, Walkerjs } from '@elbwalker/walker.js'

const ELBWALKER_TOGGLE = 'log_elbwalker'

const ga4Config = {
  consent: {
    marketing: true
  },
  custom: {
    measurementId: 'G-WF8BMGZN9S',
    include: ['all'],
    snakeCase: true
  }
  // loadScript: true
}

// Tracking is browser-only: walker.js session state, destinations and the
// debug toggle all live on window/localStorage (VIP-12036)
if (!import.meta.env.SSR) {
  const urlParams = new URLSearchParams(window.location.search)
  const partnerId = urlParams.get('partner_id')

  // walker.js's own session.consent restarts the in-memory session on every
  // SPA run and reads the UTMs from the URL at consent time, which loses the
  // campaign of a visitor who navigates before accepting (VIP-12468).
  const landingUrl = window.location.href
  let memorySession

  // The router replaces walker's user on every run, and without storage
  // walker.js only reports the session in the first run.
  const keepMemorySession = (session, instance, defaultCb) => {
    if (session.id) memorySession = session
    else if (memorySession && !session.storage)
      session = { ...memorySession, isStart: false, storage: false }

    return defaultCb(session, instance, defaultCb)
  }

  // CookieFirst's performance category arrives as analytics, renamed in
  // external_scripts/elbwalker.js. elbDeviceId/elbSessionId need it.
  const switchSessionStorage = (instance, { analytics }) => {
    const session = instance.config.session
    const granted = Boolean(analytics)
    if (session.storage === granted) return

    session.storage = granted
    if (!granted) return

    delete session.isStart
    // Before the first run walker.js starts the session on the landing page itself
    if (instance.round > 0)
      instance.sessionStart({
        config: { pulse: false, url: landingUrl },
        data: {}
      })
  }

  window.walkerjs = Walkerjs({
    session: {
      storage: CookieFirstHelper.getPerformanceConsent() === true,
      length: 30,
      cb: keepMemorySession,
      data: {
        partner_id: partnerId
      }
    },
    on: {
      consent: [{ analytics: switchSessionStorage }]
    }
  })
  window.elb = elb

  // Add destinations
  elb(WALKER_COMMANDS.destination, {
    push: ApiController.sendEventToDataMining
  })

  if (
    import.meta.env.VITE_APP_TRACKING_ENABLED === 'ON' &&
    location.hostname === 'www.vicampo.de'
  ) {
    elb(WALKER_COMMANDS.destination, destinationGoogleGA4, ga4Config)
  }

  // Only enable console logging when explicitly 'true' (Tool/dialog toggle).
  // Avoid treating "false" as truthy when the dialog stores the boolean off state.
  if (localStorage.getItem(ELBWALKER_TOGGLE) === 'true') {
    elb(WALKER_COMMANDS.destination, { push: console.log })
  }
}
